import { writable } from 'svelte/store';

let configObj = {
    "urls": {
        backend: "https://pausenhelden-backend.herokuapp.com",
        //backend: "http://localhost:5000"
        // TODO Golive
    }
}


const configStore = writable(configObj);


export default configStore;